import PropTypes from 'prop-types';
import * as Icon from 'react-bootstrap-icons';
import { useSelector } from 'react-redux';

import { Forbidden, LightButton, TextInputPreview } from '../../../components';

import styles from '../Modals.module.css';
import { colors } from '../../../types/types';

export const EventoAgendaModal = ({ cita = null, hide, editarCita, eliminarCita }) => {

    const { permisos } = useSelector(state => state.auth);

    return (permisos.eventoRead || permisos.eventoUpdate || permisos.eventoDelete) ? (
        <>
            <div className={styles.topCloseButtonContainer}>
                <div className={styles.topCloseButton} onClick={hide}>
                    <Icon.X color={colors.DANGER} size={30} />
                </div>
                <div className="row mb-3">
                    <div className="col">
                        <div className={styles.modalHeader}>Detalles de evento</div>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <TextInputPreview
                            label="Nombre de evento"
                            name="name"
                            value={ (typeof cita.datosPaciente !== 'undefined') ? cita.datosPaciente : '' }
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6 col-lg-3">
                        <TextInputPreview
                            label="Desde"
                            name="dia"
                            value={ cita.dia }
                        />
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <TextInputPreview
                            label=""
                            name="hora"
                            value={ cita.hora }
                        />
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <TextInputPreview
                            label="Hasta"
                            name="dia"
                            value={ cita.diaFin }
                        />
                    </div>
                    <div className="col-md-6 col-lg-3">
                        <TextInputPreview
                            label=""
                            name="hora"
                            value={ cita.horaFin }
                        />
                    </div>
                </div>
                {(typeof cita.comentario !== 'undefined' && cita.comentario !== '') &&
                <div className="row">
                    <div className="col-md-12 col-lg-6">
                        <TextInputPreview
                            label="Comentario"
                            name="comentario"
                            value={ cita.comentario }
                        />
                    </div>
                </div>
                }
                <div className="row">
                    {(!cita.confirmada && !cita.atendida) &&
                    <>
                    {(permisos.eventoUpdate && !cita.atendida) &&
                    <div className="col">
                        {/* iconMargin={2} */}
                        {/* iconSize="0.7" */}
                        {/* icon="Calendar3" */}
                        <LightButton
                            block={true}
                            marginTop={false}
                            onClick={ editarCita }
                            text={<div>
                                    <div>Editar</div>
                                    <div>evento</div>
                                </div>}
                            type="button"
                        />
                    </div>
                    }
                    {(permisos.eventoDelete && !cita.atendida) &&
                    <div className="col">
                        {/* iconMargin={2} */}
                        {/* iconSize="0.7" */}
                        {/* icon="Calendar2X" */}
                        <LightButton
                            block={true}
                            marginTop={false}
                            onClick={ eliminarCita }
                            text={<div>
                                    <div>Eliminar</div>
                                    <div>evento</div>
                                </div>}
                            type="button"
                        />
                    </div>
                    }
                    </>
                    }
                </div>
            </div>
        </>
    ) : <Forbidden />
}

EventoAgendaModal.propTypes = {
  cita: PropTypes.object,
  hide: PropTypes.func.isRequired,
  editarCita: PropTypes.func.isRequired,
  eliminarCita: PropTypes.func.isRequired,
}